import React, { useState, useEffect } from "react";
import pauseBtn from "../../../assets/images/bingo/pause-btn.png";
import backArrow from "../../../assets/images/bingo/back-arrow.png";
import rightArrow from "../../../assets/images/bingo/right-arrow.png";
import userImg from "../../../assets/images/bingo/user-img.png";
import crossIcon from "../../../assets/images/bingo/cross-icon.png";
import game_Paused_img from "../../../assets/images/bingo/Game_Paused_img.png";
import BingoUsers from "../../../components/bingo/BingoUsers";

const AllPlayersSideBar = ({ users }) => {
  const [allPlayers, setAllPlayers] = useState(false);
  const handleAllPlayer = () => {
    setAllPlayers(!allPlayers);
  };

  return (
    <>
      {!allPlayers && (
        <div className="players-toggle">
          <p className="players-toggle-btn" onClick={() => handleAllPlayer()}>
            <img src={backArrow} alt="" className="back-arrow" />
            players
          </p>
        </div>
      )}
      {allPlayers && (
        <div className="bingo-players-sideout-container">
          <div className="bingo-players-sideout">
            <div className="close-allPlayer-toggle">
              <p className="close-toggle-btn" onClick={() => handleAllPlayer()}>
                <img src={rightArrow} alt="" className="right-arrow" />
                close
              </p>
            </div>
            {/* <div className="text-center py-4">
            <h2>players</h2>
          </div> */}
            {/* <div className="players-list"> */}
            {/* <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div> */}
            <BingoUsers />

            {/* <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div>
            <div className="players-wrapper">
              <div className="player-img">
                <img src={userImg} alt="img" />
                <h4 className="username">Giovanni Hernandez</h4>
              </div>
              <img src={crossIcon} className="cross-icon" alt="cross icon" />
            </div> */}
            {/* </div> */}
          </div>
        </div>
      )}
    </>
  );
};
export default AllPlayersSideBar;
